import React, {useState} from 'react';
import {getUserFriendlyErrorMessage} from '@/utils/errorHandling.ts';
import {
  Button,
  ButtonVariant,
  Label,
  useModal,
  useToast
} from '@fs/uikit-react';
import styles from './ContactLinkCategoryModalDelete.module.css';
import { ContactLinkCategory } from '@/shared/model/contactLinkCategory.ts';
import { ContactLinkCategoriesApi } from '@/shared/api/ContactLinkCategoriesApi.ts';
import {ApiError} from "@/services/api";

interface DeleteModalProps {
  item: ContactLinkCategory;
  onSuccess: () => void;
}

const ContactLinkCategoryModalDelete: React.FC<DeleteModalProps> = ({ item, onSuccess }) => {
  const { closeModal } = useModal();
  const toast = useToast();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);

    try {
      await ContactLinkCategoriesApi.delete(item.id);

      toast.showSuccessToast('Успішно', 'Категорію видалено');

      closeModal();
      onSuccess();
    } catch (error) {
      console.error('Error deleting contact link category:', error);
      toast.showErrorToast('Помилка видалення категорії',
        getUserFriendlyErrorMessage(error as ApiError));
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className={styles.modalContent}>
      <Label
        text={`Ви впевнені, що хочете видалити категорію "${item.name}"?\nПовернути її назад в каталог буде неможливо.`}
      />

      <div className={styles.buttonGroup}>
        <Button
          variant={ButtonVariant.DESTRUCTIVE}
          title={isDeleting ? 'Видалення...' : 'Видалити'}
          onClick={handleDelete}
          disabled={isDeleting}
        />
        <Button
          variant={ButtonVariant.SECONDARY}
          title="Скасувати"
          onClick={closeModal}
        />
      </div>
    </div>
  );
};

export default ContactLinkCategoryModalDelete;
